export class ListSapJobsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobs",
            "baseName": "jobs",
            "type": "Array<SapJob>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSapJobsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
